export function setColor(color: string) {
  return `var(--bs-${color})`;
}
